<!--
 * @Author: your name
 * @Date: 2020-07-15 11:37:57
 * @LastEditTime: 2021-02-02 11:03:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-supplier\components\feedback\index.vue
-->
<template>
  <div class="side-fixed">
    <div class="side-fixed-content">
      <ul class="other-side-fixed shadow-contain">
        <li v-if="talkIconShow" class="side-fixed-item" @click="talk">
          <el-tooltip
            effect="light"
            :content="pageText.myCustomerService"
            placement="left"
          >
            <div class="icon-container">
              <i class="iconfont icon-shangcheng-zhinengkefu"></i>
            </div>
          </el-tooltip>
        </li>
        <li class="side-fixed-item" v-if="type === 'fluid'">
          <el-tooltip
            effect="light"
            :content="pageText.processTitle"
            placement="left"
          >
            <header-process-popover class="process" :show="processListShow" :limit="3" ref="process" @update:show="popoverVisible"/>
          </el-tooltip>
        </li>
        <li class="side-fixed-item" @click="openDialog" v-if="isShowFeedback">
          <el-tooltip
            effect="light"
            :content="pageText.feedback"
            placement="left"
          >
            <div class="icon-container" :title="pageText.feedback">
              <i class="iconfont icon-shangcheng-yijianfankui"></i>
            </div>
          </el-tooltip>
          <div v-if="showFeedbackTip" @click.stop class="tooltip">
            <div class="content">
              <img class="icon" :src="syImgUrl + '164196777811379949.png'" alt="">
              <div class="text">{{pageText.feedbackTips}}</div>
            </div>
            <div class="foot">
              <span class="font-color-link" @click="setFeedbackTipKey">{{pageText.iKonw}}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="go-to-top shadow-contain" @click="scrollToTop" v-show="isShowGoToTop">
        <div class="side-fixed-item">
          <el-tooltip
            effect="light"
            :content="pageText.goTop"
            placement="left"
          >
            <div class="icon-container">
              <i class="iconfont icon-shangcheng-fanhuidingbu"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <ChatWindow :talkShow.sync="talkShow" :ChatWindowBuriedPoint="ChatWindowBuriedPoint"/>
    <feedback-dialog ref="feedbackDialog"></feedback-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import response from 'fe-coms/utils/response'
import Api from './api.js'
import mallPublicApi from '../mall-public//api.js'
import FeedbackDialog from 'fe-coms/components/business/feedback/feedback-dialog'
import HeaderProcessPopover from 'fe-coms/components/business/header-process-popover'
import ChatWindow from 'fe-coms/components/business/ai-service/chat-window/index.vue'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'index',
  components: {
    FeedbackDialog,
    HeaderProcessPopover,
    ChatWindow
  },
  props: {
    type: {
      type: String,
      default: 'fixed'
    }
  },
  created () {
    this.getIsShowFeedback()
    this.getHelpOpenMenu()
    this.getFeedbackTipKey()
  },
  data () {
    return {
      pageText,
      talkIconShow: false,
      talkShow: false,
      isShowFeedback: false,
      processListShow: false,
      isShowGoToTop: false,
      ChatWindowBuriedPoint: {
        sendBuriedPoint: 'd16',
        openBuriedPoint: 'd19',
        toHelpCenter: 'd22',
        toViewDetails: 'd25',
        toMinus: 'd28',
        toClose: 'd31'
      },
      showFeedbackTip: 0
    }
  },
  computed: {
    ...mapGetters(['visible']),
    ...mapState({
      isAuth: state => state.user.isAuth
    })
  },
  watch: {
    visible (show) {
      if (this.processListShow) {
        this.$refs.process.getProcess()
      }
      this.processListShow = true
    }
  },
  methods: {
    talk () {
      this.talkShow = true
    },
    openDialog () {
      if (!this.isAuth) {
        this.toLogin()
        return
      }
      this.$refs.feedbackDialog.open()
    },
    async toLogin () {
      const api = Api.getLoginUser
      response(this.$http(api.type, api.url, {authError: true, showError: false}))
    },
    getFeedbackTipKey () {
      const feedbackTipCatchKey = window.localStorage.getItem('feedbackTipCatchKey')
      this.showFeedbackTip = feedbackTipCatchKey ? 0 : 1
    },
    setFeedbackTipKey () {
      window.localStorage.setItem('feedbackTipCatchKey', '1')
      this.showFeedbackTip = false
    },
    async getHelpOpenMenu () {
      console.log(mallPublicApi)
      let api = mallPublicApi.isOpenMenu
      let params = {appCode: 'knowledge_management'}
      let result = await response(this.$http(api.type, api.url, params))
      if (result.code === 'success' && result.content) {
        this.talkIconShow = true
      }
    },
    async getIsShowFeedback () {
      let api = Api.getConfig
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        if (res.content === '0') {
          //  0 启用 1 不启用
          this.isShowFeedback = true
        } else {
          this.isShowFeedback = false
        }
      }
    },
    popoverVisible (visible) {
      this.processListShow = visible
    },
    scrollToTop () {
      document.getElementById('app').scrollIntoView()
    }
  },
  mounted () {
    //检测屏幕高度
    document.addEventListener('scroll', (e) => {
      let scrollTop = window.scrollY || document.body.scrollTop || document.documentElement.scrollTop || 0
      if (scrollTop > 320) {
        this.isShowGoToTop = true
      } else {
        this.isShowGoToTop = false
      }
    })
  }
}
</script>

<style scoped lang="scss">
.side-fixed{
  position: fixed;
  // bottom: 232px;
  // left: calc(50% + 608px);
  bottom: 80px;
  right: 8px;
  z-index: 1999;
  .side-fixed-content{
    position: relative;
  }
  .shadow-contain{
    width: 50px;
    cursor: pointer;
    text-align: center;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px rgba(101, 112, 150, 0.05);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    .side-fixed-item{
      width: 44px;
      height: 44px;
      margin: 8px auto;
      box-sizing: border-box;
      position: relative;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #F3F4FA;
      }
      &:first-child {
        &::before {
          display: none;
        }
        .icon-container {
          margin-top: 0;
        }
      }
      &::before {
        content: "";
        width: 16px;
        height: 1px;
        background: #E2E7F4;
        display: block;
        margin: 0 auto;
        position: absolute;
        top: -8px;
      }
      .process {
        display: block;
        color: #636E95;
        ::v-deep.iconfont {
          font-size: 18px;
        }
      }
      .icon-container{
        width: 30px;
        height: 30px;
        margin: 10px auto 0;
        box-sizing: border-box;
        i{
          font-size: 18px;
          color: #636E95;
        }
      }
      .tooltip {
        position: absolute;
        right: 60px;
        top: -50px;
        width: 278px;
        background: #fff;
        padding: 10px 10px 12px 10px;
        box-sizing: border-box;
        border-radius: 4px;
        box-shadow: 0px 0px 20px rgba(99, 110, 149, 0.25);
        z-index: 1000;
        &::after,
        &::before {
          content: '';
          position: absolute;
          background: #fff;
        }
        &::after {
          right: 0px;
          bottom: 58px;
          width: 10px;
          height: 30px;
        }
        &::before {
          bottom: 68px;
          right: -5px;
          width: 10px;
          height: 10px;
          transform: rotate(-45deg);
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);;
        }
        & > .content {
          color: #242F57;
          font-size: 14px;
          line-height: 20px;
          background: rgba(48,114,243, 0.05);
          border-radius: 4px;
          padding: 12px 15px 12px 17px;
          overflow: hidden;
          & > .icon {
            width: 18px;
            float: left;
          }
          & > .text {
            margin-left: 10px;
            float: left;
            width: 198px;
            text-align: left;
          }
        }
        & > .foot {
          margin-top: 12px;
          font-size: 14px;
          text-align: right;
        }
      }
    }
  }
  .go-to-top{
    margin-top: 16px;
    position: absolute;
  }
}
</style>

<style lang="scss">
.side-fixed-process-popover{
  padding: 0;
}
.side-fixed-process-popover {
  .trigger-icon {
    font-size: 16px;
  }
  .avatar-wrap {
    float: left;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border: 2px solid #eee;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .info-wrap {
    margin-left: 50px;
    font-size: 12px;
    line-height: 1;
    color: #333;
    padding: 3px 0;
    height: 40px;
    box-sizing: border-box;
  }
  .user-name {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  .handle-wrap {
    margin-top: 10px;
    font-size: 0;
    span,
    a {
      color: #666;
      display: inline-block;
      padding-right: 8px;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        color: currentColor;
      }
      & + span {
        padding-left: 8px;
        padding-right: 0;
        border-left: 1px solid #eee;
      }
      & + a {
        padding-left: 8px;
        padding-right: 0;
        border-left: 1px solid #eee;
      }
    }
  }
}
</style>
